



























































import { Component, Vue } from 'vue-property-decorator'
import Alert from '@/components/ui/Alert.vue'
/**
 * 还原订单 orderType 7
 */
@Component({
  components: {
    Alert
  }
})
export default class RecycleBin extends Vue {
  private delAlert: boolean = false
  private restore: boolean = false
  protected reduction() {
    this.restore = true
  }
  protected delOrder() {
    this.delAlert = true
  }
  protected SureRecharge() {
    alert('删除')
  }
  protected isReduction() {
    alert('还原成功')
  }
}
